// todo: can't figure out how to change the primary color of mui icon button. Fix This
export const COLOR_SUCCESS = "#256141";
export const COLOR_PRIMARY = "#C8932A";
